import { AssetType } from '../../../api/models/Shared.types';
import { GlobalSettingsKeys } from '../../../api/models/GlobalSettingsKeys';
import { BookmarkID } from '../../../api/user';
import { IBookmarkUpdateV1, IProgramV5, ISeriesV5 } from '../../../api/models/AndromeTV.types';
import { VodAsset } from '../../detail/vod/VodAsset';
import { Backend } from '../../../api/Backend';

export class Bookmark {
  id: BookmarkID;
  value: IBookmarkUpdateV1;
  endOffset: number;

  constructor(id: BookmarkID, value: IBookmarkUpdateV1, endOffset = 0) {
    this.id = id;
    this.value = value;
    this.endOffset = endOffset / 1000;
  }

  static fromVod(vod: VodAsset, position: number): Bookmark {
    const id = {
      type: AssetType.VOD,
      id: vod.assetId,
    };

    const value: IBookmarkUpdateV1 = {
      series: vod.seriesId,
      size: 0,
      position: position,
    };

    return new Bookmark(id, value);
  }

  static fromProgram(program: IProgramV5, position: number, series: ISeriesV5 | undefined, backend: Backend) {
    const id = {
      type: AssetType.PROGRAM,
      id: program.programId,
    };

    const value: IBookmarkUpdateV1 = {
      series: series ? series.seriesId : undefined,
      size: 0,
      position: position,
    };

    const endOffset = backend.globalSettings.numberValue(GlobalSettingsKeys.playerEpgBookmarkEndOffset) || 20000;

    return new Bookmark(id, value, endOffset);
  }

  /**
   * @param {number} position
   * @param {number} duration
   */
  updateTime(position: number, duration: number) {
    this.value.size = duration * 1000;
    this.value.position = position * 1000;
  }
}
